import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useHistory } from 'react-router';
import AdminActionsPopup from '../../../admin-actions-popup/AdminActionsPopup';
import PropTypes from 'prop-types';
import { GetNewTaskTypeSettings } from '../../../../../../services/api/task-types-api';

const TaskTypesTableRow = (props) => {
    const { taskType, canArchive, selectedTaskTypes, setSelectedTaskTypes, refreshTaskTypes, user } =
        props;
    const [showAdminActionsPopup, setShowAdminActionsPopup] = useState(false);

    const history = useHistory();

    function onArchive() {
        // TODO check for privileges
        setShowAdminActionsPopup(true);
    }

    const goToDynamicFields = async () => {
        let isNewTaskType = false;
        const result = await GetNewTaskTypeSettings(taskType.Id);
        if (result?.status === 200) {
            isNewTaskType = result.data;
        }
        const pathname = isNewTaskType
            ? `/admin/task-types/task-type/${taskType.Id}`
            : `/admin/task-types/dynamic-fields/${taskType.Id}`;
        history.push({
            pathname,
            state: { taskType },
        });
    };

    function onSelect(e) {
        if (e.target.checked) {
            setSelectedTaskTypes([...selectedTaskTypes, taskType.Id]);
        } else {
            setSelectedTaskTypes(
                selectedTaskTypes.filter((selectedTaskType) => selectedTaskType !== taskType.Id)
            );
        }
    }

    // TAD-5783 -- Multi-admin Task Type Access. The Edit / Archive gate is now
    // computed on the server (super admin or admin who shares at least one
    // sub-department with the creator). Fall back to the legacy client rule when
    // the field is missing (older payloads / unit tests) so we don't break the
    // existing flow during rollout.
    const isEditable = typeof taskType.IsEditable === 'boolean'
        ? taskType.IsEditable
        : (taskType.CreatorUserId === user.profile.userID) || user.profile.isSuperAdminRole;

    // TAD-5783 -- Fall back to '-' when the payload has SubDepartments rows with
    // missing/empty Name values (filter would otherwise leave a join of empty
    // strings, rendering nothing).
    const subDepartmentNames = (Array.isArray(taskType.SubDepartments) ? taskType.SubDepartments : [])
        .map((s) => s?.Name)
        .filter(Boolean);
    const subDepartmentsLabel = subDepartmentNames.length > 0 ? subDepartmentNames.join(', ') : '-';

    const ownerLabel =
        taskType.CreatorName && String(taskType.CreatorName).trim() !== ''
            ? String(taskType.CreatorName).trim()
            : '-';

    const adminActionsPopupProps = {
        showAdminActionsPopup,
        setShowAdminActionsPopup,
        type: 'task type',
        name: taskType.Type,
        selectedIDs: [taskType.Id],
        refreshTaskTypes,
    };

    return (
        <>
            <tr className="template-row-1">
                <td className="th-checkbox-col">
                    <Form.Check
                        type="checkbox"
                        disabled={!canArchive || !isEditable}
                        onChange={onSelect}
                        checked={selectedTaskTypes.includes(taskType.Id)}
                    ></Form.Check>
                </td>
                <td className="data-text template-name">{taskType.Type}</td>
                <td className="data-text task-types-subdept-col" title={subDepartmentsLabel}>
                    {subDepartmentsLabel}
                </td>
                <td className="data-text task-types-owner-col" title={ownerLabel}>
                    {ownerLabel}
                </td>
                <td className="admin-row-action-buttons">
                    <Button
                        className={`btn-icon1 archive-icon1`}
                        disabled={!isEditable}
                        onClick={onArchive}
                        title="Archive"
                    ></Button>
                    <Button
                        className={`btn-icon1 edit-icon1`}
                        disabled={!isEditable}
                        onClick={goToDynamicFields}
                        title="Edit"
                    ></Button>
                </td>
                <td className='type-access'>
                    <div className="description">
                        {taskType.IsPublic ? 'Public' : 'Private'}
                    </div>
                </td>
            </tr>
            {showAdminActionsPopup && <AdminActionsPopup {...adminActionsPopupProps} />}
        </>
    );
};

const subDepartmentRefShape = PropTypes.shape({
    Id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    Name: PropTypes.string,
});

TaskTypesTableRow.propTypes = {
    taskType: PropTypes.shape({
        Id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        Type: PropTypes.string,
        CreatorUserId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        IsPublic: PropTypes.bool,
        IsEditable: PropTypes.bool,
        SubDepartments: PropTypes.arrayOf(subDepartmentRefShape),
        CreatorName: PropTypes.string,
    }).isRequired,
    canArchive: PropTypes.bool.isRequired,
    selectedTaskTypes: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    ).isRequired,
    setSelectedTaskTypes: PropTypes.func.isRequired,
    refreshTaskTypes: PropTypes.func.isRequired,
    user: PropTypes.shape({
        profile: PropTypes.shape({
            userID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            isSuperAdminRole: PropTypes.bool,
        }).isRequired,
    }).isRequired,
};

export default TaskTypesTableRow;
